
















































import { ErrorCodes } from '@ringana/errors';
import Vue from 'vue';
import { IFetchConfig } from '@/common/interfaces/common.interface';
import CustomButton from '@/components/layout/buttons/CustomButton.vue';
import Overlay from '@/components/layout/Overlay.vue';
import TextInput from '@/components/myprofile/inputs/TextInput.vue';
import OldErrorHandlerHelper from '@/helpers/OldErrorHandlerHelper';
import OldFetchHelper from '@/helpers/OldFetchHelper';
import ValidationHelper from '@/helpers/ValidationHelper';
import config from '../../../config';

interface IPartnerChangeCustomerMailAddressOverlayComponent {
  loading: boolean;
  mailAddress: string | null;
}

export default Vue.extend({
  name: `PartnerChangeCustomerMailAddressOverlay`,
  components: { CustomButton, Overlay, TextInput },
  data(): IPartnerChangeCustomerMailAddressOverlayComponent {
    return {
      loading: false,
      mailAddress: null,
    };
  },
  props: {
    customerNumber: {
      required: true,
      validator: val => ValidationHelper.isNumberOrNull(val),
    },
  },
  methods: {
    async addCustomerMailAddress(): Promise<void> {
      if(!this.mailAddress) {
        return;
      }
      this.loading = true;
      const fetchConfig: IFetchConfig = {
        body: { customerNumber: this.customerNumber, email: this.mailAddress },
        path: `${config.api.paths.customers.basepath}${config.api.paths.customers.paths.partnerUpdateCustomerMailAddress}`,
      };
      const fetchResult: { success: true } | { error: ErrorCodes | string; message: string; success: false } = await OldFetchHelper.patch(fetchConfig);
      if(fetchResult.success) {
        await this.$swal(``, this.$t(`my-profile:myProfile.api.success.customerDataSavedChangedEmail`), `success`);
        this.closeOverlay();
      } else if(fetchResult.error === `ERR_INFOWORX` || fetchResult.error === ErrorCodes.INFOWORX_RESPONSE_UPDATE_CUSTOMER) {
        OldErrorHandlerHelper.handleError(fetchResult.message, { showSwal: true });
      } else {
        OldErrorHandlerHelper.handleError(this.$t(`my-profile:myProfile.api.success.cannotSaveCustomerData`), { showSwal: true });
      }
      this.loading = false;
    },
    closeOverlay(): void {
      this.mailAddress = null;
      this.$emit(`close:overlay`);
    },
  },
});
